import LoginErrorHandlerBase from './login_error_hadler_base';
import {CGP_ERROR_CODES} from '../../../exceptions/cgp_error_codes';

export default class TokenNotValidErrorHandler extends LoginErrorHandlerBase {
    static CLASS = 'TokenNotValidErrorHandler';

    _handledErrorCode() {
        return CGP_ERROR_CODES.TOKEN_NOT_VALID;
    }

    handle(errorProcessingResult) {
        this.serviceFactory.oAuth2Service().clearTokenInfoFromLocalStorage();
    }
}
